import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useRaffleDrawContext } from '../provider';
import Description from './mail-description';
import Settings from './mail-settings';
import UpdateProvider, { useUpdateContext } from './provider';
import { BootstrapDialog, StyledActionContainer, StyledButtonCancel, StyledButtonSave } from './styles.css';
import _ from 'lodash';

function EditDialog() {

  return (
    <UpdateProvider>
      <Component />
    </UpdateProvider>
  );
}


function Component() {
  const { state: STATE, openEdit } = useRaffleDrawContext();
  const { isLoading, onUpdating } = useUpdateContext();

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="md"
      open={!_.isEmpty(STATE.editDetails)}
      onClose={() => openEdit(null)} >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        {"EDIT RAFFLE DRAW FORM"}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Description />
          <Settings />
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledActionContainer>
          <StyledButtonCancel variant='outlined' onClick={() => openEdit(null)} >CANCEL</StyledButtonCancel>
          <StyledButtonSave
            variant="contained"
            form="game-details-form"
            type="submit"
            loading={isLoading}
            onClick={onUpdating}
          >
            SAVE
          </StyledButtonSave>
        </StyledActionContainer>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default EditDialog;